






























import { mapState } from 'vuex';
import { LOADER_DELAY, LOADER_SLOW } from '@/constants';
import Logo from '@/components/Logo.vue';

interface IParams {
  title: string;
  promise: Promise<any>;
}

interface ILoadItem extends IParams {
  id: number;
}

export default {
  props: ['text'],
  created() {
    this.$store.registerModule('loader', {
      namespaced: true,
      state: () => ({
        loaders: [] as ILoadItem[],
      }),
      mutations: {
        ADD: (state: any, { title, promise }: IParams) => {
          const id = Math.random();

          // if there are currently no loaders
          // start measuring when to display slow loading message
          if (!this.takingLongTimeout) {
            this.takingLongTimeout = setTimeout(() => {
              this.takingLong = true;
            }, LOADER_SLOW);
          }

          state.loaders = [...state.loaders, {
            id,
            title,
            promise: promise.finally(() => {
              // timeout allows other movements behind view to happen first
              setTimeout(() => {
                // remove current loader from list of loaders
                state.loaders = state
                  .loaders
                  .filter((loader: ILoadItem) => loader.id !== id);

                // reset slow loading message when no loaders exist
                if (!state.loaders.length) {
                  clearTimeout(this.takingLongTimeout);
                  this.takingLongTimeout = null;
                  this.takingLong = false;
                }
              }, LOADER_DELAY);
            }),
          }];
        },
      },
    });
  },
  data: () => ({
    takingLong: false,
    takingLongTimeout: null,
  }),
  computed: mapState('loader', ['loaders']),
  methods: {
    reload() {
      window.location.reload();
    },
  },
  components: {
    Logo,
  },
} as IView;
